import main from "./app";

import "./static/images/favicon.png";
import "./static/images/logo_120x120.png";
import "./static/images/logo_180x180.png";
import "./styles/main.scss";

// Render main app.
main();
